/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-video.modal-common .modal-dialog,.modal-video.modal-news .modal-dialog{max-width:calc(.5em + 750px)}.modal-video .modal-header{background-color:#0080ff;color:#fff}.modal-video .modal-body iframe{border:0}.modal-video .modal-header .close-btn{background:transparent;border:0;outline:none;cursor:pointer;line-height:1em}.modal-video .modal-header .close-btn span{font-size:1.5em;color:#fff}.error-container{max-width:250px;padding:150px 0}.error-container img{width:98px;height:98px}.error-container span{color:#444}.error-container a,.error-container span{font-family:PoppinsRegular,Arial,Helvetica,sans-serif}.error-container a{color:#ff6000!important;cursor:pointer}"];
export { styles as styles };
//# sourceMappingURL=media-player.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/media-player/media-player.component.scss.ngstyle.js
// module id = 1099
// module chunks = 26 27 28